import React from "react";
import PropTypes from "prop-types";
import BoxOfficeSearchForm from "./BoxOfficeSearchForm";
import { printerSettings } from "../../../../redux/printers/selectors";
import { selectEvent } from "../../../../redux/preferences/selectors";
import { connect } from "react-redux";

class _BoxOfficeSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    event: PropTypes.object,
    printerSettings: PropTypes.object
  };

  render() {
    const { event, printerSettings } = this.props;
    return (
      <BoxOfficeSearchForm event={event} printerSettings={printerSettings} />
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state),
    printerSettings: printerSettings(state)
  };
};

const BoxOfficeSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(_BoxOfficeSearch);

export default BoxOfficeSearch;
